module.exports = __webpack_public_path__ + "static/media/Ruby_On_Rails_Logo.97bc7b45.svg";